import {
    SUBSCRIPTION_LISTING_REQUEST, SUBSCRIPTION_LISTING_FAIL, SUBSCRIPTION_LISTING_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
    loading: false,
    action: "Job Action",
    result: null,
    msg: "",
    error: "",
};

const SubscriptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBSCRIPTION_LISTING_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };
        case SUBSCRIPTION_LISTING_SUCCESS:
            return {
                ...state,
                result: action.result.data,
                loading: action.payload,
                msg: action.msg,
            };
        case SUBSCRIPTION_LISTING_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default SubscriptionReducer;
